import React from "react";
import {
  Box,
  Stack,
  Button,
  Container,
  Grid,
  Paper,
  Card,
  CardContent,
  CardActions,
  Typography,
  Divider,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import WaterlooLogo from "../../util/WaterlooLogo";

const MoveIn = () => {
  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          bgcolor: "#5D0096",
          color: "white",
          borderRadius: 0,
          py: 6,
          mb: 4,
        }}
      >
        <Container maxWidth="lg">
          <Stack spacing={3} alignItems="center" textAlign="center">
            <Typography
              variant="h2"
              fontWeight="bold"
              sx={{ fontSize: { xs: "2.2rem", md: "3.2rem" } }}
            >
              Move-In Information
            </Typography>
            <Typography
              variant="h5"
              sx={{ maxWidth: 900, lineHeight: 1.9, opacity: 0.95 }}
            >
              Welcome to the University of Waterloo! If you are planning to stay
              in the Campus Residences in your incoming term, see below for the
              best places to look for Move In information!
            </Typography>
          </Stack>
        </Container>
      </Paper>

      <Container maxWidth="lg" sx={{ pb: 6 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card
              elevation={3}
              sx={{
                height: "100%",
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                <Stack spacing={1.5} alignItems="center" textAlign="center">
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h3">Dates</Typography>
                    <CalendarMonthIcon
                      sx={{ fontSize: "1.25em", color: "primary.main" }}
                    />
                  </Stack>
                  <Divider sx={{ width: "100%", my: 1 }} />
                  <Typography
                    variant="h5"
                    align="center"
                    sx={{ maxWidth: 800, lineHeight: 1.9 }}
                  >
                    Saturday, September 5, 2026
                    <br />─ to ─<br />
                    Sunday, September 6, 2026
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              elevation={3}
              sx={{
                height: "100%",
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                  <Typography variant="h3">Residence Move-Ins</Typography>
                  <Divider sx={{ width: "100%", my: 1 }} />
                  <Typography
                    variant="h5"
                    align="center"
                    sx={{ maxWidth: 800, lineHeight: 1.9 }}
                  >
                    Looking for Residence Maps, Move-In times, FAQ on what to
                    bring to Residence, etc? Head to the Campus Housing Move Ins
                    page for all the information you will need to get settled
                    into residence.
                  </Typography>
                </Stack>
              </CardContent>
              <CardActions sx={{ p: 2.5, pt: 0 }}>
                <Box width="100%" display="flex" justifyContent="center">
                  <Button
                    variant="contained"
                    color="engPrimary"
                    onClick={() =>
                      window.open(
                        "https://uwaterloo.ca/campus-housing/moving-fy",
                        "_blank",
                      )
                    }
                    sx={{
                      fontSize: "1.05em",
                      px: 2,
                      py: 1,
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <span>Move In Information</span>
                      <WaterlooLogo style={{ maxHeight: "28px" }} />
                    </Stack>
                  </Button>
                </Box>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 3,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                  <Typography variant="h3">Orientation Calendar</Typography>
                  <Divider sx={{ width: "100%", my: 1 }} />
                  <Typography
                    variant="h5"
                    align="center"
                    sx={{ maxWidth: 800, lineHeight: 1.9 }}
                  >
                    Check your Portal calendar for the move-in timelines,
                    orientation check-in dates/times, and even more info on
                    Orientation Week events.
                  </Typography>
                </Stack>
              </CardContent>
              <CardActions sx={{ p: 2.5, pt: 0 }}>
                <Box width="100%" display="flex" justifyContent="center">
                  <Button
                    variant="contained"
                    color="engPrimary"
                    onClick={() =>
                      window.open(
                        "https://portal.uwaterloo.ca/#/calendar",
                        "_blank",
                      )
                    }
                    sx={{
                      fontSize: "1.05em",
                      px: 2,
                      py: 1,
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <span>Orientation Calendar</span>
                      <img
                        src="/images/resource-logos/portal_inv.png"
                        alt="Portal Logo"
                        style={{ maxHeight: "28px", objectFit: "contain" }}
                      />
                    </Stack>
                  </Button>
                </Box>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default MoveIn;
